import React, { Component } from 'react';
import { connect } from 'react-redux'

import './first-page.css';
import CategoryButton from './CategoryButton';
import Spacer from '../common/Spacer';
import { Link } from "react-router-dom";
import { addCategories,removeSubCategories } from '../actions'
import {api} from '../services';

import micro from '../assets/mikro@2x.png';
import olje from '../assets/Oljevaxt@2x.png';
import potatis from '../assets/potatis@2x.png';
import strasad from '../assets/strasad@2x.png';

class FirstPage extends Component {

  constructor(props) {
    super(props);

    this.state = {
      categories: []
    };
  }

  componentWillMount(){
      this.props.dispatch(removeSubCategories());
  }

  componentDidMount(){
    api.getMainCategories().then(categories => {
      this.props.dispatch(addCategories(categories));
      this.setState({
        categories: [...categories]
      });
    });
  }

  render() {

    /*{categories.map((cat) => (
      <Link key={cat.value} to={"/category/" + cat.value}><CategoryButton name={cat.text} logo={logo}></CategoryButton></Link>
    ))}*/

    let categories = this.state.categories;

    return (
      <div className="first-page">
        <div className="first-page-category">
          <h3>Välj kategori</h3>
          <Spacer/>
        </div>
        <div className="first-page-button-container">
              <Link key={1} to={"/category/" + 1}><CategoryButton name={"Stråsäd"} logo={strasad}></CategoryButton></Link>
              <Link key={2} to={"/category/" + 2}><CategoryButton name={"Potatis"} logo={potatis}></CategoryButton></Link>
              <Link key={3} to={"/category/" + 3}><CategoryButton name={"Oljeväxter"} logo={olje}></CategoryButton></Link>
              <Link key={4} to={"/category/" + 4}><CategoryButton name={"Mikronäring"} logo={micro}></CategoryButton></Link>
        </div>
      </div>
    );
  }
}

export default connect()(FirstPage);
